import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

export default function ReportDetailsSkeleton() {
  return (
    <Paper sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
        <Box>
          <Skeleton variant="text" width={180} height={28} />
          <Skeleton variant="text" width={120} height={20} />
        </Box>
        <Skeleton variant="rounded" width={100} height={36} />
      </Stack>

      <Divider sx={{ mb: 2 }} />

      <Stack direction="row" gap={1} mb={2}>
        <Skeleton variant="rounded" width={120} height={36} />
        <Skeleton variant="rounded" width={120} height={36} />
      </Stack>

      <Stack spacing={1.5}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Paper key={i} sx={{ p: 1.5 }}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Skeleton variant="circular" width={32} height={32} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="60%" height={22} />
                <Skeleton variant="text" width="40%" height={18} />
              </Box>
              <Skeleton variant="rounded" width={60} height={24} />
            </Stack>
          </Paper>
        ))}
      </Stack>

      <Divider sx={{ my: 2 }} />

      <Stack direction="row" justifyContent="space-between">
        <Skeleton variant="text" width={120} height={20} />
        <Skeleton variant="rounded" width={140} height={40} />
      </Stack>
    </Paper>
  );
}
